module.exports = __webpack_public_path__ + "static/media/empty-captions.a1a10e84.vtt";